<template>
  <div>
    <router-view></router-view>
    <dialog-loading v-if="loading" loadingText='Checando placa...'></dialog-loading>
    <CreateCard route_back="IndexTrucks" model_name="novo veículo" :saving="saving">
      <template slot="form">
        <v-form v-model="valid">
          <v-stepper v-model="stepper_count" vertical class="ml-1 mr-1 elevation-0">
            <v-stepper-step :complete="stepper_count > 0" step="0" editable>
              Selecionar solução
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 0" step="0">
              <v-card color="white lighten-1" class="ma-3">
                <SelectModality class="pa-3 pt-6" :object_with_model="vehicle" multiple model="modality_ids" custom_label="Selecione os módulos disponiveis para o veículo"/>
              </v-card>
              <v-btn text @click="stepper_count = 1"><v-icon large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="stepper_count > 1" step="1" :editable="stepper_count > 1">
              Placas e Chassis
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 1" step="1">
              <PlateForm ref="form_1" :vehicle="vehicle" @changePlateCount="handleChangePlateCount"></PlateForm>
              <v-btn text @click="stepper_count = 0"><v-icon large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
              <v-btn text @click="checkForm"><v-icon large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
            </v-stepper-content>
    

            <v-stepper-step :complete="stepper_count > 2" step="2" :editable="stepper_count > 2">Propriedade e Capacidade Máxima</v-stepper-step>
            <v-stepper-content step="2">
              <PropsForm ref="form_2" :vehicle="vehicle"></PropsForm>
              <v-btn text @click="stepper_count = 1"><v-icon large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
              <v-btn text @click="checkForm"><v-icon large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
            </v-stepper-content>
    

            <v-stepper-step :complete="stepper_count > 3" step="3" :editable="stepper_count > 3">Informações Gerais e Documentos</v-stepper-step>
            <v-stepper-content step="3">
              <InfoForm ref="form_3" :vehicle="vehicle" is_creating :plate_count="plate_count"></InfoForm>
              <v-btn text @click="stepper_count = 2"><v-icon large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
              <v-tooltip top :disabled="true">
                <template v-slot:activator="{ on }">
                  <v-btn color="success" v-on="on" @click="submitVehicle()" :disabled="!valid">
                    <strong>Salvar</strong></v-btn>
                </template>
                <h4>Necessário anexar arquivo(s)</h4>
              </v-tooltip>    
            </v-stepper-content>
    
          </v-stepper>
        </v-form>
      </template>
    </CreateCard>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapState } from 'vuex';
export default {
  name:"CreateTruck",
  components:{
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    SelectDepot: () => import("@/_backoffice/_registrations/components/shared/SelectDepot.vue"),
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
    InfoForm: () => import("@/_backoffice/_registrations/components/trucks/forms/InfoForm.vue"),
    PlateForm: () => import("@/_backoffice/_registrations/components/trucks/forms/PlateForm.vue"),
    PropsForm: () => import("@/_backoffice/_registrations/components/trucks/forms/PropsForm.vue"),
    SelectModality: () => import("@/components/shared/SelectModality.vue"),
  },
  data() {
    return {
      valid: true,
      saving: false,
      loading: false,

      stepper_count: 0,
      plate_count: 1,
      rules: {
        required: v => !!v || 'Campo é necessário',
      },
      vehicle: {
        modality_ids: [],
        plate:'',
        chassi:'',
        truck_kind:'',
        cargo_plate_1:'',
        cargo_plate_2:'',
        cargo_chassi_1:'',
        cargo_chassi_2:'',
        max_capacity: null,
        type: '',
        manufacturer: null,
        color: null,
        model: null,
        oneFile: null,
        internal:false,
      },
    }
  },
  computed: {
    isMobile() {
      if (document.body.clientWidth < 700)
        return true
      else
        return false
    },
  },
  methods: {
    resetForm(){
      this.vehicle = {
        modality_ids: [],
        plate:'',
        chassi:'',
        truck_kind:'',
        cargo_plate_1:'',
        cargo_plate_2:'',
        cargo_chassi_1:'',
        cargo_chassi_2:'',
        max_capacity: null,
        type: '',
        manufacturer: null,
        color: null,
        model: null,
        oneFile: null,
        internal:false,
      }
      this.stepper_count = 0
      this.plate_count = 1
    },
    checkPlates(){
      let plates = [this.vehicle.plate, this.vehicle.cargo_plate_1, this.vehicle.cargo_plate_2 ]
      this.loading = true
      Api.Truck.checkPlates(plates).then(res => res.data).then(data =>{
        if(data.id){
          this.$router.push({name:"TruckExist",params:{id: data.id}})
          return
        }else{
          this.stepper_count++
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    checkForm(){
      if(this.$refs[`form_${this.stepper_count}`].validate()){
        if(this.stepper_count == 1){
          this.checkPlates()
        }else{
          this.stepper_count++
        }
      }else{
        this.addNotification({type: 'error',  msg: "Preencha todos os campos."})
      }
    },
    submitVehicle() {
      if (this.$refs[`form_3`].validate()) {
        this.swallConfirmation({
          title: 'Deseja atualizar informações do veículo?',
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            this.saving = true

            Api.Truck.create(this.vehicle).then(res => res.data).then(data =>{
              this.$refs['form_3'].createFiles(data.id)
              this.resetForm()
              this.addNotification({type: 'success',  msg: `Veículo cadastrado com sucesso!`})
              
            }).catch(err => {
              this.addNotification({type: 'error',  msg: err})
            }).finally(()=>{
              this.saving = false
            })
          }
        })
      } else {
        this.addNotification({type: 'error',  msg: `Preencha todos os campos!`})
      }
    },
    handleChangePlateCount(nv){
      this.plate_count = nv
    }
  },
  watch:{
    plate_count(nv,old){
      if(nv > old){
        this.stepper_count = 0
        setTimeout(()=>{
          this.stepper_count = 1 
        }, 1)
      }
    }
  }
}
</script>